import type { OnboardingUserType } from '@super/shared-types'
import { progressStepsFor } from './flow.config'
import type { OnboardingStep } from './flow.config'

interface OnboardingProgressBarProps {
  currentStep: OnboardingStep
  userType: OnboardingUserType | null
}

export function OnboardingProgressBar({
  currentStep,
  userType,
}: OnboardingProgressBarProps) {
  const steps = progressStepsFor(userType)
  const currentIndex = steps.findIndex(s => s.id === currentStep.id)

  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={steps.length}
      aria-valuenow={Math.max(0, currentIndex + 1)}
      className="mx-auto flex w-full max-w-[840px] gap-[2px] px-4"
    >
      {steps.map((step, i) => {
        const filled = i <= currentIndex
        return (
          <span
            key={step.id}
            className={`h-[2px] flex-1 ${
              filled ? 'bg-foreground' : 'bg-foreground/15'
            }`}
          />
        )
      })}
    </div>
  )
}
